import React from 'react';
import Sphere from './ASSETS/SHAPES/Sphere';
import Cylinder from './ASSETS/SHAPES/Cylinder';
import Cone from './ASSETS/SHAPES/Cone';
import Cube from './ASSETS/SHAPES/Cube';
import Prism from './ASSETS/SHAPES/Prism';
import Pyramid from './ASSETS/SHAPES/Pyramid';
import Ring from './ASSETS/SHAPES/Ring';
import Octahedron from './ASSETS/SHAPES/Octahedron';

const Icon = props => {
  const { colors } = props;
  switch (props.name) {
    case 'cone':
      return <Cone colors={colors} />;
    case 'cube':
      return <Cube colors={colors} />;
    case 'cylinder':
      return <Cylinder colors={colors} />;
    case 'octahedron':
      return <Octahedron colors={colors} />;
    case 'prism':
      return <Prism colors={colors} />;
    case 'pyramid':
      return <Pyramid colors={colors} />;
    case 'ring':
      return <Ring colors={colors} />;
    case 'sphere':
      return <Sphere colors={colors} />;
    default:
      return;
  }
};

export default Icon;
